import styles from "../../styles/createTest/AddAudience.css";
import { makeClassNameFunctionForModule } from "../../utils/cssModules";

const className = makeClassNameFunctionForModule(styles);

export { styles, className };



// WEBPACK FOOTER //
// ./src/components/CreateTest/audienceStyles.js